import React from "react";
import axios from "axios";

import { axiosDelay } from "../../config/config";

import {
    REPORT_CONFIGURED_FETCH,
    REPORT_STATUS_FETCH,
    REPORT_CREATE_FETCH,
    REPORT_SELECTED
} from "./reportTypes";

// Initiates create action
export function reportCreateFetch(gid, report, reportLabel) {
    return (dispatch, getState) => {
        const state = getState();

        dispatch({
            type: REPORT_CREATE_FETCH,
            payload: {
                fetching: true,
                fetched: false,
                data: null,
                error: null
            }
        });
        if (!gid)
            return;

        const config = state.config.data;
        const program = config.title.replaceAll(" ", "").toLowerCase();
        program.replace(/[^A-Z0-9]/ig, "");
        const username = state.user.email.split('@')[0];
        const database = config.authentication.apiSource;
        const loaderAPIUri = config.dataLoader.apiDataLoader;

        // Create Report
        const getRequest = "{0}Report/Create?program={1}&username={2}&report={3}&reportLabel={4}&gId={5}&db={6}".format(loaderAPIUri, program, username, report, reportLabel, gid, database);

        setTimeout(function(){
            axios.get(getRequest)
                .then(function (response) {
                    // console.log('create report response', response);

                    // TODO: Assume 3-5 seconds for upload but this may have to be tweeked
                    // or initiated from the Step 2. Upload...
                    setTimeout(() => {
                        dispatch({
                            type: REPORT_CREATE_FETCH,
                            payload: {
                                fetching: false,
                                fetched: true,
                                data: response.data,
                                error: null
                            }
                        });

                        // // Reload the list
                        // dispatch(reportListFetch(gid));

                    }, 5000);

                }).catch(function (error) {
                    console.log('**ERROR**', error);

                    dispatch({
                        type: REPORT_CREATE_FETCH,
                        payload: {
                            fetching: false,
                            fetched: true,
                            data: null,
                            error: error
                        }
                    });
                });
        }, JSON.parse(axiosDelay()))

    };
}

// Returns the reports configured in [Report]
export function reportAvailableFetch(gid) {
    return (dispatch, getState) => {
        const state = getState();

        dispatch({
            type: REPORT_CONFIGURED_FETCH,
            payload: {
                fetching: true,
                fetched: false,
                data: null,
                error: null
            }
        });

        const config = state.config.data;
        const program = config.title.replaceAll(" ", "").toLowerCase();
        program.replace(/[^A-Z0-9]/ig, "");
        const username = state.user.email.split('@')[0];
        const database = config.authentication.apiSource;
        const loaderAPIUri = config.dataLoader.apiDataLoader;

        // Reports that can be created for this GID
        const getRequest = '{0}Report/AvailableReports?program={1}&username={2}&gid={3}&db={4}'.format(loaderAPIUri, program, username, gid, database);

        setTimeout(function(){
            axios.get(getRequest)
                .then(function (response) {
                    // console.log('available reports response', response);

                    dispatch({
                        type: REPORT_CONFIGURED_FETCH,
                        payload: {
                            fetching: false,
                            fetched: true,
                            data: response.data,
                            error: null
                        }
                    });

                }).catch(function (error) {
                    console.log('**ERROR**', error);

                    dispatch({
                        type: REPORT_CONFIGURED_FETCH,
                        payload: {
                            fetching: false,
                            fetched: true,
                            data: null,
                            error: error
                        }
                    });
                });
        }, JSON.parse(axiosDelay()))

    };
}

// Returns the status of the specified report
export function reportStatusFetch(gid, report) {
    return (dispatch, getState) => {
        const state = getState();

        dispatch({
            type: REPORT_STATUS_FETCH,
            payload: {
                fetching: true,
                fetched: false,
                data: null,
                error: null
            }
        });
        if (!gid)
            return;

        const auth = state.auth;
        const config = state.config.data;
        const program = config.title.replaceAll(" ", "").toLowerCase();
        program.replace(/[^A-Z0-9]/ig, "");
        const username = state.user.email.split('@')[0];
        const database = config.authentication.apiSource;
        const loaderAPIUri = config.dataLoader.apiDataLoader;

        // Report Status
        const getRequest = '{0}Report/ReportStatus?program={1}&username={2}&report={3}&gid={4}&db={5}'.format(loaderAPIUri, program, username, report, gid, database);

        setTimeout(function(){
            axios.get(getRequest)
                .then(function (response) {
                    // console.log('status response', response);

                    dispatch({
                        type: REPORT_STATUS_FETCH,
                        payload: {
                            fetching: false,
                            fetched: true,
                            data: response.data,
                            error: null
                        }
                    });

                }).catch(function (error) {
                    console.log('**ERROR**', error);

                    dispatch({
                        type: REPORT_STATUS_FETCH,
                        payload: {
                            fetching: false,
                            fetched: true,
                            data: null,
                            error: error
                        }
                    });
                });
        }, JSON.parse(axiosDelay()))

    };
}

export function reportSetSelected(reportInfo) {
    return (dispatch) => {

        dispatch({
            type: REPORT_SELECTED,
            payload: reportInfo
        });
    }
}
